import React,{useEffect,useState} from "react";
import styled from "styled-components";
import CryptidCard from "./shared/cryptidCard";
import { FlexContainer } from "./styled";
import NoDataImage from "../assets/images/noData.png";
import { floating, fadeInUp } from "./styled/animations";


const SelectCardModalContent = ({ cryptids, onSelect, multipleSelection, selectedCards: currentCards = [], limit }) => {
  const [selectedCards, setSelectedCards] = useState([...currentCards]);
  if(!cryptids || !Array.isArray(cryptids) || cryptids.length === 0){
    cryptids = [];

  };
  if(cryptids.length === 0){
    return <FlexContainer>
      <img src={NoDataImage} alt="No Data" />
    </FlexContainer>
  }
  const selectCaryptid = (cryptid) => {
    if (selectedCards.some((item) => item?._id === cryptid?._id)) {
      setSelectedCards((prev) =>
        prev.filter((item) => item?._id !== cryptid?._id)
      );
    } else {
      if (limit && selectedCards.length === limit)
        return alert(`You can make a maximum of ${limit} selections.`);
      setSelectedCards((prev) => [...prev, cryptid]);
    }
  };
  return (
    <Container style={{paddingBottom:multipleSelection && selectedCards.length ? 100 : 0}}>
      {React.Children.toArray(
      cryptids.map((cryptid) => (       
        <CardContainer onClick={() => multipleSelection ? selectCaryptid(cryptid) : onSelect(cryptid)}>
          {multipleSelection &&
               selectedCards.some((item) => item?._id === cryptid?._id) && (
                 <SelectedOverlay>
                   <SelectedText>Selected</SelectedText>
                 </SelectedOverlay>
               )}
            {cryptid?.name &&
                 <CryptidCard
                 cryptid={cryptid}
                 inDeck={true}
               />
            }
        </CardContainer>
      )))
      }
      {cryptids.length < 8 &&
      React.Children.toArray(
          Array(8 - cryptids.length).fill(0).map((_,i) => <CardContainer key={i} />
      ))}
      {multipleSelection && selectedCards.length ? (
        <ConfirmButtonContainer>
          <ConfirmButton onClick={() => onSelect(selectedCards)}>
           Confirm
         </ConfirmButton>
        </ConfirmButtonContainer>
       ) : null}
    </Container>
  );
}

const Container = styled.div`
    display:grid;
    grid-template-columns: repeat(4,1fr);
    width: 100%;
    padding: 0 10px;
    gap: 8px;
    max-height: 80vh;
    padding-bottom: 34px;
    overflow-y: auto;
    place-items: center;
`
const CardContainer = styled.div`
    width: 100%;
    height: auto;
    aspect-ratio: 859/1320;
    border-radius: 10px;
    background-color:#FFFFFF1A;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    box-shadow: 0px 4px 4px 0px #FFFFFF40 inset;

`
const ConfirmButtonContainer = styled(FlexContainer)`
    position: fixed;
    bottom: calc(40px + var(--tg-safe-area-inset-bottom, 0px));
`
const ConfirmButton = styled.button`
   border: none;
   padding-inline: 25px;
   padding-block: 15px;
   background: ${(props) => props.theme.colors.gradient1};
   animation: ${fadeInUp} 0.4s ease-out forwards,
     ${floating} 3s ease-in-out infinite;
   color: #fff;
   font-size: 16px;
   border-radius: 99px; 
   width: 200px;
 `;

 const SelectedOverlay = styled.div`
   position: absolute;
   width: 100%;
   height: 100%;
   background-color: rgba(0, 0, 0, 0.5);
   z-index: 5;
   border-radius: 9px;
   display: flex;
   align-items: center;
   justify-content: center;
   transition: all 0.3 ease-in-out;
 `;
 
 const SelectedText = styled.p`
   color: #fff;
   font-size: 13px;
   animation: ${fadeInUp} 0.4s ease-out forwards;
 `;

export default SelectCardModalContent;